import type { SearchResult } from "../defs";
import { SearchItemDocument } from "./SearchItemDocument";
import { SearchItemEvent } from "./SearchItemEvent";
import { SearchItemLibrary } from "./SearchItemLibrary";
import { SearchItemNews } from "./SearchItemNews";
import { SearchItemPage } from "./SearchItemPage";

export function SearchItem(props: SearchResult) {
  const { itemType } = props;
  if (itemType === "DmsDocNodeLibrary") {
    return <SearchItemLibrary {...props} />;
  }
  if (itemType === "DmsDocNodeDocument") {
    return <SearchItemDocument {...props} />;
  }
  if (itemType === "Event") {
    return <SearchItemEvent {...props} />;
  }
  if (itemType === "News") {
    return <SearchItemNews {...props} />;
  }
  if (itemType === "Page") {
    return <SearchItemPage {...props} />;
  }
  return null;
}
